import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ParkMachineCategorySerializer from '../../../services/park-machine/ParkMachineCategorySerializer';
import * as modalActions from '../../../actions/common/modalActions';
import * as submitButtonActions from '../../../actions/submit/submitButtonActions';
import {toastr} from 'react-redux-toastr';
import {injectIntl} from 'react-intl';
import {messages} from  '../../common/Translations';
import WithResolvedPromises from "../../common/WithResolvedPromises";
import Placeholder from "../../Placeholder";
import PlaceholderError from "../../common/PlaceholderError";
import ResetFormModal from "../../ResetFormModal";
import * as parkMachineCategoryActions from "../../../actions/park-machine/parkMachineCategoryActions";
import CategoryForm from "./CategoryForm";

class CategoryFormContainer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.submit = this.submit.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.actions = this.getRequiredActions();
    }

    getRequiredActions() {
        let actions = [];
        if(this.isUpdate()) {
            actions.push(this.props.actions.getParkMachineCategory(this.props.match.params.id))
        }

        return actions;
    }

    componentDidMount() {
        if(!this.isUpdate()) {
            this.props.actions.resetParkMachineCategory();
        }
    }

    submit(formFields) {
        this.props.actions.showSubmitButtonSpinner();
        let fields = ParkMachineCategorySerializer.serialize(formFields);

        if(this.isUpdate()) {
            this.props.actions.updateParkMachineCategory(fields, formFields.id)
                .then(() => {
                    toastr.success('Kategorien blev opdateret');
                    this.redirect();
                })
                .finally(() => this.props.actions.hideSubmitButtonSpinner());
        } else {
            this.props.actions.saveParkMachineCategory(fields)
                .then(() => {
                    toastr.success('Kategori blev ikke opdateret');
                    this.redirect();
                })
                .finally(() => this.props.actions.hideSubmitButtonSpinner());
        }
    }

    confirmReset() {
        this.props.actions.hideResetFormModal();
        this.redirect();
    }

    handleReset() {
        this.props.actions.showResetFormModal();
    }

    isUpdate() {
        return this.props.match.params.hasOwnProperty('id');
    }

    redirect() {
        this.context.router.history.push('/park/kategorier');
    }

    render() {
        return (
            <WithResolvedPromises preloaderComponent={Placeholder} promises={this.actions} errorComponent={PlaceholderError}>
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <h1 className="mb-3">Maskinkategorier</h1>
                                <CategoryForm
                                    initialValues={this.props.parkMachineCategory}
                                    onSubmit={this.submit}
                                    handleReset={this.handleReset}
                                    isUpdate={this.isUpdate()}
                                />
                            </div>
                        </div>
                    </div>
                    <ResetFormModal
                        modalTitle={"Nulstil ændringer"}
                        modalContent={<p> Er du sikker på at du vil annullere? Alle dine ændringer vil gå tabt </p>}
                        confirmText={this.props.intl.formatMessage(messages.buttonYes)}
                        closeText={this.props.intl.formatMessage(messages.buttonNo)}
                        handleConfirm={() => {this.confirmReset()}}
                    />
                </div>
            </WithResolvedPromises>
        );
    }
}

CategoryFormContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    let parkMachineCategory = ParkMachineCategorySerializer.unserialize(state.parkMachineCategory);
    return { parkMachineCategory};
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...parkMachineCategoryActions,
            ...submitButtonActions,
            ...modalActions,
        }, dispatch)
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CategoryFormContainer));





// WEBPACK FOOTER //
// ./web/src/components/park-machine/category/CategoryFormContainer.jsx